import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { GROUP_CHAT_HUB_HTTP_URL } from "../../config/serviceConfig";
import ChatStream from "./ChatStream";
import "./ArchiveView.css";

/**
 * 群聊存档查看：只读展示历史消息，无输入
 */
const ArchiveView = ({ roomId, projectName, currentUser, onBack }) => {
  const { t } = useTranslation();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saveLoading, setSaveLoading] = useState(false);
  const [saveMsg, setSaveMsg] = useState(null);

  useEffect(() => {
    if (!roomId) return;
    setLoading(true);
    setError(null);
    fetch(`${GROUP_CHAT_HUB_HTTP_URL}/groupchat/rooms/${roomId}/messages`)
      .then((res) => res.json())
      .then((data) => {
        if (data.error) {
          setError(data.error);
          setMessages([]);
        } else {
          const msgs = (data.messages || []).map((m) => ({
            seq: m.seq,
            senderType: m.senderType || "student",
            senderId: m.senderId,
            senderName: m.senderName,
            senderRole: m.senderRole,
            content: m.content,
            type: m.senderType === "agent" || m.senderType === "host" ? "agent" : m.senderType === "system" ? "phase" : "student",
          }));
          setMessages(msgs);
        }
      })
      .catch((e) => {
        setError(e.message || "加载失败");
        setMessages([]);
      })
      .finally(() => setLoading(false));
  }, [roomId]);

  const handleSaveToTrainingArchives = async () => {
    if (!roomId) return;
    const username = currentUser?.username ?? currentUser?.unified_user_id ?? currentUser?.userId ?? "anonymous";
    setSaveLoading(true);
    setSaveMsg(null);
    try {
      const res = await fetch(
        `${GROUP_CHAT_HUB_HTTP_URL}/groupchat/archive/saveToTrainingFromHistory?roomId=${encodeURIComponent(roomId)}&username=${encodeURIComponent(username)}`,
        { method: "POST" }
      );
      const data = await res.json().catch(() => ({}));
      if (res.ok && data.ok) {
        setSaveMsg({ ok: true, text: data.message || "已保存到存档列表" });
      } else {
        setSaveMsg({ ok: false, text: data.error || "保存失败" });
      }
    } catch (err) {
      setSaveMsg({ ok: false, text: err.message || "保存失败" });
    } finally {
      setSaveLoading(false);
    }
  };

  return (
    <div className="archive-view">
      <div className="archive-view-header">
        <button className="archive-view-back" onClick={onBack}>
          ← {t("groupchat.back") || "返回"}
        </button>
        <h3 className="archive-view-title">
          {projectName || roomId} — {t("groupchat.lobby.view_archive") || "查看记录"}
        </h3>
        <button
          className="archive-view-save-btn"
          onClick={handleSaveToTrainingArchives}
          disabled={saveLoading}
        >
          {saveLoading ? t("groupchat.loading") : t("groupchat.save_to_archives")}
        </button>
        {saveMsg?.ok && (
          <span className="archive-view-save-ok">✓ {saveMsg.text}</span>
        )}
        {saveMsg && !saveMsg.ok && (
          <span className="archive-view-save-err">{saveMsg.text}</span>
        )}
      </div>
      <div className="archive-view-body">
        {loading && (
          <div className="archive-view-loading">
            {t("groupchat.lobby.loading") || "加载中..."}
          </div>
        )}
        {error && (
          <div className="archive-view-error">{error}</div>
        )}
        {!loading && !error && messages.length === 0 && (
          <div className="archive-view-empty">
            {t("groupchat.archive_empty") || "暂无消息记录"}
          </div>
        )}
        {!loading && !error && messages.length > 0 && (
          <ChatStream
            messages={messages}
            streamingContent={{}}
            myUserId=""
          />
        )}
      </div>
    </div>
  );
};

export default ArchiveView;
